export const GET_INSTRUMENT_FAMILIES = "GET_INSTRUMENT_FAMILIES";
export const GET_INSTRUMENT_FAMILY_BY_ID = "GET_INSTRUMENT_FAMILY_BY_ID";
export const UPDATE_INSTRUMENT_FAMILY = "UPDATE_INSTRUMENT_FAMILY";
export const DELETE_INSTRUMENT_FAMILY = "DELETE_INSTRUMENT_FAMILY";
export const CREATE_INSTRUMENT_FAMILY = "CREATE_INSTRUMENT_FAMILY";
